'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fileModel = require('./file-model');

var _fileModel2 = _interopRequireDefault(_fileModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('webPublicClient.creditRequest.shared.components', []).directive('fileModel', _fileModel2.default);


// WEBPACK FOOTER //
// ./src/credit-request/shared/components/index.js